import { CommaList } from "Components/CommaList";
import { Horizontal } from "Components/Horizontal";
import { PageNumberProps } from "Components/PageNumber";
import { Program } from "SharedConstants";
import React from "react";
import {
  StandardAIInput,
  StandardAIInputProps,
} from "Views/Shared/StandardAIInput";
import { Heading, TitleProps } from "../../Components/Heading";
import { MVCForm, MVCFormServerProps } from "../MVCForm";
import { ModelStateValues } from "../Tools";
import { useDocumentTitle } from "Components/Hooks";

export function AdditionalInsureds(props: {
  formProps: MVCFormServerProps;

  StandardAIInputProps: StandardAIInputProps;
  TitleProps: TitleProps;
  PageNumberProps: PageNumberProps;
  IsInlineSkatingProducer: boolean;
}) {
  const getInitialValues = (values: ModelStateValues) => {
    return {
      ...values,
    };
  };

  const title = "Additional Insureds";
  useDocumentTitle(`${title} - ${props.TitleProps.PageTitleSuffix}`);
  return (
    <>
      <Heading {...props} title={title} />
      <MVCForm
        {...props.formProps}
        initialValues={getInitialValues(props.formProps.initialValues)}
      >
        {({ isSubmitting }) => (
          <div>
            <StandardAIInput
              {...props.StandardAIInputProps}
              isSubmitting={isSubmitting}
            />
          </div>
        )}
      </MVCForm>
    </>
  );
}
